import * as React from "react";
import PropTypes from 'prop-types';

const SvgCheck = props => {
  if (props.id !== "_svgcheck") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><g fill="#008a44"><path d="M217.532 119.976c-3.288-.209-6.162 2.288-6.379 5.596-1.528 23.348-11.722 44.991-28.704 60.942-17.058 16.021-39.46 24.846-63.08 24.846-24.696 0-47.831-9.533-65.142-26.844s-26.845-40.444-26.845-65.141 9.534-47.831 26.845-65.141S94.673 27.39 119.369 27.39c9.715 0 19.265 1.481 28.384 4.404a6 6 0 003.662-11.428c-10.305-3.302-21.087-4.976-32.046-4.976-27.901 0-54.049 10.781-73.627 30.358s-30.359 45.725-30.359 73.626c0 27.901 10.782 54.049 30.359 73.626s45.726 30.358 73.627 30.358c26.685 0 52.005-9.979 71.296-28.1 19.206-18.04 30.735-42.512 32.463-68.905a6 6 0 00-5.596-6.377z" /><path d="M82.198 115.132a6 6 0 00-8.485 8.485l32.007 32.008a5.98 5.98 0 004.243 1.758 5.982 5.982 0 004.242-1.757l94.202-94.191a5.999 5.999 0 10-8.484-8.485l-89.959 89.948-27.766-27.766z" /></g></svg>;
};

SvgCheck.displayName = "_svgcheck";
SvgCheck.propTypes = {
  id: PropTypes.string
};
SvgCheck.defaultProps = {
  id: ''
};
export default SvgCheck;